import { render, staticRenderFns } from "./newDealCompany.vue?vue&type=template&id=e65bbf9a&scoped=true"
import script from "./newDealCompany.vue?vue&type=script&lang=js"
export * from "./newDealCompany.vue?vue&type=script&lang=js"
import style0 from "./newDealCompany.vue?vue&type=style&index=0&id=e65bbf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65bbf9a",
  null
  
)

export default component.exports